export const CHART_AGGREGATORS = {
  HIGH: 'high',
  AVERAGE: 'average',
  LOW: 'low',
  SUM: 'sum',
  CUSTOM_FREQUENCY: 'customFrequency',
  WEIGHTED_AVERAGE: 'weightedAverage',
};

export const AGGREGATORS = {
  HIGH: 'high',
  AVERAGE: 'average',
  LOW: 'low',
  CLOSE: 'close',
  COUNT: 'count',
  SUM: 'sum',
  FREQUENCY: 'frequency',
  PERCENTAGE: 'percentage',
  WEIGHTED_AVERAGE: 'weightedAverage',
};

export const CHART_TYPE = {
  COLUMN: 'column',
  LINE: 'line',
  LINECHART: 'linechart',
  SCATTERCHART: 'scatterchart',
  SCATTERPLOT: 'scatterplot',
  LOGARITHMIC: 'logarithmic',
  STACKED: 'stacked',
};

/**
 * Data series presets,
 * used in Insights mixin + Data Sources
 */
export const DS_ID = {
  ASSESSMENT: 'dsAssessmentData',
  BEHAVIOR_INCIDENT: 'dsBehaviorIncidentDataFlat',
  SESSION: 'dsSessionData',
  SESSION_TRIAL: 'dsSessionTrialData',
  TARGETS: 'dsTargets',
};
